export default __webpack_public_path__ + "static/media/logo.ca2ccdb3.svg";